[
  {
    "code": "SH-AC",
    "name": "Ascension"
  },
  {
    "code": "SH-SH",
    "name": "Saint Helena"
  },
  {
    "code": "SH-TA",
    "name": "Tristan da Cunha"
  }
]